import { render, staticRenderFns } from "./TomatoDiseaseAnalysis.vue?vue&type=template&id=79bafa14&"
import script from "./TomatoDiseaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./TomatoDiseaseAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports